import React, { useEffect, useId, useRef, useState } from "react";
import { searchBrands } from "../../../api/marketplacePricingApi";

// Поиск бренда по полю «Виробник» мастер-каталога; выбор фиксирует точное написание.
export default function BrandAutocomplete({ platform, accountId, value, onChange, disabled }) {
    const [query, setQuery] = useState(value || "");
    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const [active, setActive] = useState(-1);
    const timer = useRef(null);
    const listId = useId();

    useEffect(() => {
        setQuery(value || "");
    }, [value]);

    useEffect(() => () => clearTimeout(timer.current), []);

    const lookup = (text) => {
        clearTimeout(timer.current);
        if (text.trim().length < 2) {
            setOptions([]);
            setOpen(false);
            return;
        }
        timer.current = setTimeout(async () => {
            try {
                const rows = await searchBrands(platform, accountId, text.trim());
                setOptions(rows || []);
                setOpen(true);
                setActive(-1);
            } catch (error) {
                setOptions([]);
                setOpen(false);
            }
        }, 300);
    };

    const choose = (brand) => {
        setQuery(brand);
        onChange(brand);
        setOpen(false);
    };

    const onKeyDown = (event) => {
        if (!open || !options.length) return;
        if (event.key === "ArrowDown") {
            event.preventDefault();
            setActive((index) => Math.min(index + 1, options.length - 1));
        } else if (event.key === "ArrowUp") {
            event.preventDefault();
            setActive((index) => Math.max(index - 1, 0));
        } else if (event.key === "Enter" && active >= 0) {
            event.preventDefault();
            choose(options[active].brand);
        } else if (event.key === "Escape") {
            setOpen(false);
        }
    };

    return (
        <div className="mp-autocomplete">
            <input
                className="mp-input"
                aria-label="Бренд"
                role="combobox"
                aria-controls={listId}
                aria-expanded={open ? "true" : "false"}
                aria-autocomplete="list"
                value={query}
                disabled={disabled}
                placeholder="Начните вводить бренд"
                onChange={(event) => {
                    setQuery(event.target.value);
                    onChange(event.target.value);
                    lookup(event.target.value);
                }}
                onKeyDown={onKeyDown}
                onBlur={() => setTimeout(() => setOpen(false), 150)}
            />
            {open && options.length ? (
                <ul id={listId} className="mp-autocomplete-list" role="listbox">
                    {options.map((option, index) => (
                        <li
                            key={option.brand}
                            role="option"
                            aria-selected={index === active}
                            onMouseDown={(event) => {
                                event.preventDefault();
                                choose(option.brand);
                            }}
                        >
                            <span>{option.brand}</span>
                            <span className="mp-muted">
                                {option.sku_count} SKU{option.has_rule ? " · есть правило" : ""}
                            </span>
                        </li>
                    ))}
                </ul>
            ) : null}
        </div>
    );
}
